import { defineLabels } from '@repo/locale-client';
import englishLabels from './translations/en.json' with { type: 'json' };
import polishLabels from './translations/pl.json' with { type: 'json' };
/**
 * Every string this package renders, in the language currently in effect.
 *
 * Exported from the barrel — applications render some of the same copy, and one
 * accessor keeps a key greppable from the JSON to every one of its call sites,
 * with no per-concept helper in between. Keys that stand for a domain value
 * (`TicketType`, `keyof ParkingProperties`) are named after that value, so
 * indexing needs no mapping table.
 */
export const getLabels = defineLabels({ en: englishLabels, pl: polishLabels });
